var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "bg-white md__card--holder clearfix" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "card-header d-flex align-items-center",
              class: {
                "blue-class": _vm.$route.name == "projects",
                "green-class": _vm.$route.name == "tasks.home",
                "green-class": _vm.$route.name == "tasks.quote",
                "yellow-class": _vm.$route.name == "timesheet.home",
              },
            },
            [
              _c("h4", { staticClass: "h3 mb-0" }, [
                _c("span", { staticClass: "right-bracket" }, [_vm._v("{ ")]),
                _vm._v(" Rates\n        "),
              ]),
            ]
          ),
          _c("div", { staticClass: "card-body px-0 pt-0 pb-2" }, [
            _c("div", { staticClass: "table-responsive p-0" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table align-items-center justify-content-center mb-0 table-custom-one",
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold bg-light",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center lh-1" },
                            [
                              _vm._v(
                                "\n                    Rate(" +
                                  _vm._s(
                                    _vm.profile && _vm.profile.currency.value
                                  ) +
                                  "/HR)\n                  "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold bg-light text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center lh-1",
                            },
                            [
                              _vm._v(
                                "\n                    Note\n                  "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold bg-light text-center",
                        },
                        [
                          _c("div", {
                            staticClass:
                              "d-flex justify-content-center align-items-center lh-1",
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm.rateData
                    ? _c(
                        "tbody",
                        [
                          _vm._l(
                            _vm.rateData.companyRates || [],
                            function (r, ind) {
                              return _c("tr", { key: ind }, [
                                _vm.model.id != r.id
                                  ? _c(
                                      "td",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm._onRateSelected(r)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v(_vm._s(r.rate))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.model.id != r.id
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm._onRateSelected(r)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v(_vm._s(r.note))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.model.id != r.id
                                  ? _c("td", { staticClass: "text-center" }, [
                                      (_vm.profile &&
                                        _vm.profile.role.name == "admin") ||
                                      (_vm.project.user_owner &&
                                        _vm.project.user_owner.user.id ==
                                          _vm.profile.id) ||
                                      _vm.isApproverForTheProject
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "pr-2",
                                              staticStyle: {
                                                height: "20px",
                                                width: "20px",
                                              },
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.model = r
                                                  _vm.showCompanyRateForm = false
                                                  _vm.editMode = true
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-edit",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.profile &&
                                        _vm.profile.role.name == "admin") ||
                                      (_vm.project.user_owner &&
                                        _vm.project.user_owner.user.id ==
                                          _vm.profile.id) ||
                                      _vm.isApproverForTheProject
                                        ? _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                height: "20px",
                                                width: "20px",
                                              },
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm._onDeleteCompanyRate(
                                                    r.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-trash",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm.model.id == r.id
                                  ? _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.model.rate,
                                            expression: "model.rate",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--inside-tbl form-control--placeholder-text-lg",
                                        attrs: { placeholder: "Rate" },
                                        domProps: { value: _vm.model.rate },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.model,
                                              "rate",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm.model.id == r.id
                                  ? _c(
                                      "td",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "radius-0 border-0",
                                            staticStyle: { width: "110px" },
                                            attrs: {
                                              size: "small",
                                              "allow-create": "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.onSaveClicked()
                                              },
                                            },
                                            model: {
                                              value: _vm.model.note,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.model, "note", $$v)
                                              },
                                              expression: "model.note",
                                            },
                                          },
                                          _vm._l(
                                            ["Standard", "Strategy", "Expert"],
                                            function (option) {
                                              return _c("el-option", {
                                                key: option,
                                                staticClass: "select-danger",
                                                attrs: {
                                                  value: option,
                                                  label: option,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _vm.showCompanyRateForm && !_vm.editMode
                            ? _c("tr", [
                                _c("td", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.model.rate,
                                        expression: "model.rate",
                                      },
                                    ],
                                    staticClass:
                                      "form-control form-control--inside-tbl form-control--placeholder-text-lg",
                                    attrs: { placeholder: "Rate" },
                                    domProps: { value: _vm.model.rate },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.model,
                                          "rate",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "radius-0 border-0",
                                        staticStyle: { width: "110px" },
                                        attrs: {
                                          size: "small",
                                          "allow-create": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onSaveClicked()
                                          },
                                        },
                                        model: {
                                          value: _vm.model.note,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.model, "note", $$v)
                                          },
                                          expression: "model.note",
                                        },
                                      },
                                      _vm._l(
                                        ["Standard", "Strategy", "Expert"],
                                        function (option) {
                                          return _c("el-option", {
                                            key: option,
                                            staticClass: "select-danger",
                                            attrs: {
                                              value: option,
                                              label: option,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("tfoot", [
                    (_vm.profile && _vm.profile.role.name == "admin") ||
                    (this.project.user_owner &&
                      this.project.user_owner.user.id == this.profile.id) ||
                    _vm.isApproverForTheProject
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "3" },
                            },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: { size: "sm", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSaveClicked()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.buttonLabel))]
                              ),
                              _vm.showCompanyRateForm || _vm.editMode
                                ? _c(
                                    "base-button",
                                    {
                                      attrs: { size: "sm", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showCompanyRateForm = false
                                          _vm.model = null
                                          _vm.editMode = false
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s("Cancel"))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }